module.exports = __webpack_public_path__ + "linea-basic-10.61f3a8a387a64abfc053.woff";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-basic-10.woff
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-basic-10.woff
// module chunks = styles